/**
 * Builds an Organization JSON-LD schema
 * @param {Object} options - Configuration options for the schema
 * @returns {Object|null} Organization schema object
 */
export function buildOrganizationSchema(options = {}) {
    const { name, url, logo, socialLinks, description, areaServed, contactPoints } = options

    if (!name || !url) {
        return null
    }

    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": name,
        "url": url,
    }

    if (logo) {
        schema.logo = logo
    }

    if (description) {
        schema.description = description
    }

    if (areaServed) {
        schema.areaServed = areaServed
    }

    if (socialLinks && Array.isArray(socialLinks) && socialLinks.length > 0) {
        schema.sameAs = socialLinks
            .map(link => link.Link || link.Url || link.href || link)
            .filter(link => typeof link === 'string' && link.startsWith('http'))
    }

    if (contactPoints && Array.isArray(contactPoints) && contactPoints.length > 0) {
        schema.contactPoint = contactPoints.map(cp => ({
            "@type": "ContactPoint",
            "telephone": cp.telephone,
            "email": cp.email,
            "contactType": cp.contactType
        }))
    }

    return schema
}
